import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Form, Dropdown, Checkbox, Tag } from "antd";
import { EllipsisOutlined, StarFilled, StarOutlined, PrinterOutlined } from "@ant-design/icons";
// ... existing code ...
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { doDelete, doGet, doPatch, doPost } from "../../../API/apis";
import Notification from "../../../components/Notification/Notification";
import showConfirmModal from "../../../components/ModalConfirm/ModalConfirm";
import ViewTemplate from "./components/ViewTemplate";
import FormatDateTime from "../../../components/FormatDate/FormatDateTime";
import { maxSize, modules } from "../../../components/GlobalComponents/GlobalComponents";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { actionItems } from "../../../utils/Data";
import LabelDisplay from '../../../components/LabelDisplay/LabelDisplay'
import { useStateGlobalContext } from "../../../contexts/GlobalContext";
import Title from "../../../components/Title/Title";


const NotesTemplates = ({ isFavoriteTab = false }) => {
  const [form] = Form.useForm();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState(false);
  const [viewTemplate, setViewTemplate] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editFields, setEditFields] = useState(null);
  const [isFormReady, setIsFormReady] = useState(false);
  const [imageSize, SetImageSize] = useState(false)
  const { templates: data, getTemplates, officeSetting } = useStateGlobalContext();

  const column = [
    {
      key: 0,
      title: "",
      dataIndex: "is_fav",
      width: "3%",
      render: (is_fav, record) => (
        <div onClick={() => handleToggleFavorite(record)} className="cursor-pointer">
          {is_fav ? (
            <StarFilled style={{ color: "#fadb14", fontSize: "18px" }} />
          ) : (
            <StarOutlined style={{ fontSize: "18px" }} />
          )}
        </div>
      ),
    },
    {
      key: 1,
      title: "Title",
      dataIndex: "title",
      searchable: true,
    },
    {
      key: 2,
      title: "",
      dataIndex: "view",
      width: "10%",
      align: "center",
      render: (_, record) => (
        <Button type="link" onClick={() => handleView(record)}>
          View
        </Button>
      ),
    },
    {
      key: 3,
      title: "Added By",
      dataIndex: "added_by",
    },
    {
      key: 4,
      title: "Type",
      dataIndex: "is_lab",
      filterable: true,
      filters: [
        { text: 'Lab Template', value: true },
        { text: 'Visit Template', value: false }
      ],
      onFilter: (value, record) => record.is_lab === value,
      render: (is_lab) => (
        <Tag color={is_lab ? "blue" : "green"}>
          {is_lab ? "Lab Template" : "Visit Template"}
        </Tag>
      ),
    },
    {
      key: 5,
      title: "Added Date",
      dataIndex: "added_date",
      render: (text) => (
        <span>
          <FormatDateTime date={text} type="date" />
        </span>
      ),
    },
    {
      key: 6,
      title: "Time",
      dataIndex: "added_date",
      render: (text) => (
        <span>
          <FormatDateTime date={text} type="time" />
        </span>
      ),
    },
    {
      key: 7,
      title: "Action",
      dataIndex: "action",
      width: "5%",
      align: "center",
      render: (_, record) => {
        const availableItems = actionItems;
        return (
          <Dropdown
            menu={{
              items: [
                ...availableItems,
                { key: 4, label: "Print" }
              ].map((item) => ({
                ...item,
                onClick: () => {
                  if (item.key === 1) {
                    handleView(record);
                  } else if (item.key === 2) {
                    handleEdit(record);
                  } else if (item.key === 3) {
                    handleDelete(record.id);
                  } else if (item.key === 4) {
                    handlePrint(record);
                  }
                },
              })),
            }}
            trigger={["click"]}
          >
            <EllipsisOutlined className="cursor-pointer" />
          </Dropdown>
        );
      },
    },
  ];

  const onClick = () => {
    setVisible(true);
  };

  const handleView = (record) => {
    setViewTemplate(record);
    setView(true);
  };

  const onCancel = () => {
    setVisible(false);
    setEdit(false);
    form.resetFields();
  };

  const handleCreateTemplate = async (values) => {
    if (imageSize) {
      return Notification.error("Image Size is too large.")
    }
    setIsSubmitting(true);
    const data = {
      title: values.template_title,
      template: values.template,
      is_lab: values.is_lab || false,
      is_fav: values.is_fav || false,
    };
    try {
      const response = edit
        ? await doPatch(`/templates/update/${editFields.id}/`, data)
        : await doPost("/templates/add/", data);
      if (response.status === 200) {
        edit ? Notification.success("Template Updated Successfully") : Notification.success("Template created Successfully");
        getTemplates({ showAll: true });
        onCancel();
      }
    } catch (error) {
      Notification.error("Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (record) => {
    setEditFields(record);
    setEdit(true);
    setVisible(true);

    setTimeout(() => {
      form.setFieldsValue({
        template_title: record?.title,
        template: record?.template,
        is_lab: record?.is_lab,
        is_fav: record?.is_fav,
      });
      setIsFormReady(true);
    }, 0);
  };


  const handleDelete = (record) => {
    showConfirmModal({
      title: "Confirm Delete?",
      icon: null,
      content: "Are you sure you want to delete this?",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      className: "custom-modal",
      onOk() {
        handleDeleteConfirm(record);
      },
    });
  };

  const handleDeleteConfirm = async (id) => {
    setLoading(true)
    try {
      const response = await doDelete(`/templates/delete/${id}/`);
      if (response.status === 200) {
        Notification.success("Template Deleted Successfully");
        getTemplates({ showAll: true });
      }
    } catch {
      Notification.error("Something went wrong");
    } finally {
      setLoading(false)
    }
  };

  const handleToggleFavorite = async (record) => {
    try {
      const response = await doPatch(`/templates/update/${record.id}/`, {
        is_fav: !record.is_fav,
        template: record.template,
      });
      if (response.status === 200) {
        Notification.success(
          record.is_fav ? "Removed from Favorites" : "Added to Favorites"
        );
        getTemplates({ showAll: true });
      }
    } catch (error) {
      Notification.error("Something went wrong");
    }
  };

  const getVal = (field) => (Array.isArray(field) ? field[0] : field);

  const handlePrint = (record) => {
    const printHtml = `
      <html>
        <head>
          <title>Template - ${record.title}</title>
          <style>
            body { font-family: 'Times New Roman', serif; padding: 40px; color: black; background: white; line-height: 1.6; }
            .header { margin-bottom: 30px; border-bottom: 2px solid #000; padding-bottom: 10px; text-align: center; }
            .facility-name { font-size: 24px; font-weight: bold; margin-bottom: 5px; }
            .template-title { font-size: 20px; font-weight: bold; margin: 20px 0; text-align: center; text-decoration: underline; }
            .content { font-size: 14px; margin-top: 20px; }
            @media print {
              body { padding: 0; }
              @page { margin: 15mm; }
            }
            /* Quill specific styles to preserve formatting */
            .ql-align-center { text-align: center; }
            .ql-align-right { text-align: right; }
            .ql-align-justify { text-align: justify; }
            img { max-width: 100%; height: auto; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="facility-name">${getVal(officeSetting?.facility_name) || 'Medical Facility'}</div>
            <div style="font-size: 11px;">
              ${[
        getVal(officeSetting?.facility_address),
        getVal(officeSetting?.city),
        getVal(officeSetting?.state),
        getVal(officeSetting?.zipcode)
      ].filter(Boolean).join(', ')}
            </div>
            ${getVal(officeSetting?.office_phone) ? `<div style="font-size: 11px;">Phone: ${getVal(officeSetting?.office_phone)}</div>` : ''}
          </div>
          <div class="template-title">${record.title}</div>
          <div class="content">${record.template}</div>
        </body>
      </html>
    `;

    let iframe = document.getElementById('template-print-iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'template-print-iframe';
      iframe.style.position = 'absolute';
      iframe.style.top = '-9999px';
      iframe.style.left = '-9999px';
      document.body.appendChild(iframe);
    }

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(printHtml);
    iframeDoc.close();

    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }, 500);
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true);
      try {
        await getTemplates({ showAll: true });
      } catch (error) {
        Notification.error("Failed to load templates");
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);
  // const maxSize = 2 * 1024 * 1024; 
  const handleChange = (content, delta, source, editor) => {
    if (source === "user") {
      const imgTags = content.match(/<img[^>]+src="data:image\/[^";]+;base64,([^">]+)"/g);

      if (imgTags) {
        for (const imgTag of imgTags) {
          const base64Str = imgTag.match(/base64,([^">]+)/)[1];

          const base64Length = base64Str.length;
          const padding = base64Str.endsWith("==") ? 2 : base64Str.endsWith("=") ? 1 : 0;
          const imageSizeInBytes = (base64Length * 3) / 4 - padding;
          if (imageSizeInBytes > maxSize) {
            SetImageSize(true)
            Notification.error("Image size exceeds 2mb. Please upload a smaller image.");
          } else {
            SetImageSize(false)
          }
        }
      }
    }

    form.setFieldsValue({ template: content });
  };

  document.title = `${isFavoriteTab ? "Favorite Templates" : "Templates"} | American EMR`;
  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <Title title={isFavoriteTab ? "Favorite Templates" : "Templates"} />
        <Button type="primary" onClick={onClick}>
          Create Templates
        </Button>
      </div>

      <CustomTable
        loading={loading}
        columns={column}
        dataSource={isFavoriteTab ? data?.filter(item => item.is_fav) : data}
        key="templates_list"

      />
      <Modal
        title={edit ? "Update Template" : "Create Template"}
        footer={null}
        open={visible}
        width={900}
        onCancel={onCancel}
        maskClosable={false}
        closeIcon={
          <Button
            size="small"
            className="app-close-icon"
            shape="round"
            onClick={onCancel}
          >
            Close
          </Button>
        }
      >
        <Form layout="vertical" form={form} onFinish={handleCreateTemplate}>
          <Form.Item
            label="Title"
            name="template_title"
            rules={[
              {
                required: true,
                message: "Title is Required",
              },
            ]}
          >
            <Input placeholder="Template Title" />
          </Form.Item>
          <Form.Item
            label="Template"
            name="template"
            rules={[
              {
                required: true,
                message: "Title is Required",
              },
            ]}
          >
            <ReactQuill
              theme="snow"
              modules={modules}
              onChange={handleChange}
              style={{ height: "300px" }}
            />
          </Form.Item>
          <div className="flex justify-between mt-14">
            <div className="flex gap-4">
              <Form.Item name="is_lab" valuePropName="checked">
                <Checkbox> Show in Lab Results template </Checkbox>
              </Form.Item>
              <Form.Item name="is_fav" valuePropName="checked">
                <Checkbox> Favorite </Checkbox>
              </Form.Item>
            </div>
            <div>
              <Button onClick={onCancel}>Cancel</Button>
              <Button
                className="ml-2"
                type="primary"
                htmlType="submit"
                loading={isSubmitting}
              >
                {isSubmitting
                  ? edit
                    ? "Updating..."
                    : "Saving..."
                  : edit
                    ? "Update"
                    : "Save"}
              </Button>
            </div>
          </div>
        </Form>
      </Modal>

      <Modal
        width={900}
        title={viewTemplate?.title}
        open={view}
        closeIcon={
          <Button
            size="small"
            className="app-close-icon"
            shape="round"
            onClick={() => setView(false)}
          >
            Close
          </Button>
        }
        onCancel={() => setView(false)}
        footer={[
          <Button
            key="print"
            type="primary"
            icon={<PrinterOutlined />}
            onClick={() => handlePrint(viewTemplate)}
            style={{ backgroundColor: '#0ea5e9', borderColor: '#0ea5e9' }}
          >
            Print
          </Button>,
          <Button key="close" onClick={() => setView(false)}>
            Close
          </Button>
        ]}
      >
        <LabelDisplay title="Title" description={viewTemplate?.title} />
        <LabelDisplay title="Added By" description={viewTemplate?.added_by} />
        <LabelDisplay title="Date Added" description={<FormatDateTime date={viewTemplate?.added_date} type="datetime" />} />
        <LabelDisplay title="Lab" description={viewTemplate?.is_lab.toString() === "true" ? "Yes" : "No"} />
        <LabelDisplay className="flex-col items-start" title="Template" description={<ViewTemplate template={viewTemplate?.template} />} />
      </Modal>
    </div>
  );
};

export default NotesTemplates;
